export enum RouteParameters {
  AIRPLANE_ID = "AirplaneUniqueId",
  ORGANIZATION_ID = "organizationId",
  PERFORMANCE_ID = "PerformanceId",
  CHECKOUT_ID = "CheckoutId",
  RISK_FORM_ID = "RiskFormId",
  SQUAWK_ID = "SquawkId",
  SUPPORT_VEHICLE_ID = "SupportVehicleUniqueId",
}

export const RouteParametersArray = [
  RouteParameters.AIRPLANE_ID,
  RouteParameters.ORGANIZATION_ID,
  RouteParameters.PERFORMANCE_ID,
  RouteParameters.CHECKOUT_ID,
  RouteParameters.RISK_FORM_ID,
  RouteParameters.SQUAWK_ID,
  RouteParameters.SUPPORT_VEHICLE_ID,
] as const;
